import { ReactElement } from "react";
import { Form } from "react-bootstrap"

interface RequiredFormLabelProps {
    label: string | ReactElement;
    required?: boolean;
    errors?: any;
    name?: string;
    additionalRedLabelText?: string;
    className?: string;
    htmlFor?: string;
}
const RequiredFormLabel = ({
    label,
    required = true,
    errors = {},
    name,
    additionalRedLabelText,
    className,
    htmlFor
}: RequiredFormLabelProps) => {

    return (
        <Form.Label
            className={className}
            htmlFor={htmlFor}
        >
            {label}
            {required && <span className="red-ast">*</span>}
            {required && <span className="text-danger">{' '}{additionalRedLabelText}</span>}
            {name && errors && errors[name] && <span className="text-danger">{required ? '' : ' · '}{errors[name]}</span>}
            {/* {required && name && errors && errors[name] && <span className="text-danger">{errors[name]}</span>} */}

        </Form.Label>)
}

export default RequiredFormLabel;
